var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPredefinedQuestions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 319,
    viewBox: "0 0 266 319",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M264.583 90.2998C264.245 89.498 263.761 88.7694 263.152 88.1664L177.027 2.04102C175.795 0.795724 174.106 0.100098 172.35 0.100098H33.2245C14.9593 0.100098 0.0996094 14.9598 0.0996094 33.2249V284.975C0.0996094 311.177 21.7696 318.101 33.2245 318.101H231.975C250.24 318.101 265.1 303.241 265.1 284.976V92.85C265.1 91.9625 264.921 91.101 264.583 90.2998ZM251.85 284.976C251.85 295.934 242.933 304.851 231.975 304.851H33.2574C29.9314 304.811 13.3494 303.678 13.3494 284.976V33.2249C13.3494 22.267 22.2665 13.3499 33.2245 13.3499H169.607L242.482 86.2248H198.849C187.891 86.2248 178.974 77.3078 178.974 66.3498V46.4748C178.975 42.8184 176.007 39.8502 172.35 39.8502C168.693 39.8502 165.724 42.8184 165.724 46.4754V66.3504C165.724 84.6156 180.584 99.4753 198.849 99.4753H251.85V284.976Z",
    fill: "#343434",
    stroke: "#343434",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M218.725 159.09H46.4738C42.8168 159.09 39.8486 162.058 39.8486 165.715C39.8486 169.372 42.8168 172.34 46.4738 172.34H218.724C222.381 172.34 225.349 169.372 225.349 165.715C225.349 162.058 222.382 159.09 218.725 159.09Z",
    fill: "#343434",
    stroke: "#343434",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M218.725 198.847H46.4738C42.8168 198.847 39.8486 201.815 39.8486 205.472C39.8486 209.129 42.8168 212.098 46.4738 212.098H218.724C222.381 212.098 225.349 209.129 225.349 205.472C225.349 201.815 222.382 198.847 218.725 198.847Z",
    fill: "#343434",
    stroke: "#343434",
    strokeWidth: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M218.722 231.982H205.472C201.815 231.982 198.847 234.95 198.847 238.607C198.847 242.264 201.815 245.232 205.472 245.232H218.722C222.379 245.232 225.347 242.264 225.347 238.607C225.346 234.95 222.379 231.982 218.722 231.982Z",
    fill: "#343434",
    stroke: "#343434",
    strokeWidth: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M178.973 231.982H165.723C162.066 231.982 159.098 234.95 159.098 238.607C159.098 242.264 162.066 245.232 165.723 245.232H178.973C182.63 245.232 185.598 242.264 185.598 238.607C185.597 234.95 182.63 231.982 178.973 231.982Z",
    fill: "#343434",
    stroke: "#343434",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPredefinedQuestions);
export default __webpack_public_path__ + "static/media/Predefined Questions.955bff6ab160623400595fd5d88eb06b.svg";
export { ForwardRef as ReactComponent };